// mui
import { Button, Grid, Stack } from '@mui/material';
// form
import { useFieldArray, useForm } from 'react-hook-form';
// little-state-machine
import { useStateMachine } from 'little-state-machine';
import { defaultYearObject } from '../../../../store/form/state/currentCoverage';
// component
import { FormProvider, FieldCondition } from '../../../../components/hook-form';
import FormSectionControls from '../../FormSectionControls';
import Iconify from '../../../../components/iconify/Iconify';
// hooks
import useFormStateUpdateOnChange from '../../../../hooks/useFormStateUpdateOnChange';
import YearFields from './fields/YearFields';

// -------------------------------------------------------

const Form = () => {
  const maxPriorCarriers = 5;

  // state
  const { state } = useStateMachine();

  // form
  const methods = useForm({
    mode: 'onBlur',
    defaultValues: state.form, 
  });

  const { watch, control } = methods;

  useFormStateUpdateOnChange(watch);

  const {
    fields: currentCoverage,
    append: appendYear,
    remove: removeYear,
  } = useFieldArray({
    control,
    name: 'currentCoverage',
    defaultValues: state.form.locations,
  });

  const handleAppendYear = () => appendYear(defaultYearObject);
  const handleRemoveYear = (index) => (currentCoverage?.length > 1 ? removeYear(index) : null);

  return (
    <FormProvider methods={methods}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack spacing={2}>
            {currentCoverage?.map(({ id }, idx) => (
              <YearFields
                onRemove={handleRemoveYear}
                isRemoveDisabled={currentCoverage?.length === 1}
                index={idx}
                key={id}
              />
            ))}
          </Stack>
        </Grid>
        <FieldCondition fieldName="currentCoverage" condition={(val) => val.length < maxPriorCarriers}>
          <Grid item xs={12}>
            <Stack alignItems={'flex-end'} direction={'column'}>
              <Button
                variant={'text'}
                onClick={handleAppendYear}
                endIcon={<Iconify icon="eva:plus-fill" width={25} height={25} />}
              >
                Add Year
              </Button>
            </Stack>
          </Grid>
        </FieldCondition>
      </Grid>

      <FormSectionControls step={'current-coverage'} />
    </FormProvider>
  );
};

export default Form;
